
<app-header-user></app-header-user>
<section class="account-page mrgn-top greybg py-5">
<div class="container">
  <div class="">
  <div class="row mt-2 mt-md-0"> 

      <aside class="col-sm-6 col-md-4 col-lg-3">
        <app-userdashboard-sidebar>  </app-userdashboard-sidebar>  
      </aside>
      <div class="col-sm-6 col-md-8 col-lg-9 mt-3 mt-md-0 rside-text">
        <app-userheading-section></app-userheading-section>
        <div class="row">

            <div class="col-md-6 my-3">
                <span class="ttcvalp">
                  {{ 'myaccount.total_points' | translate }}: {{totalpoints}}
                </span>
            </div>
            <div class="col-md-6 my-3">
                <span class="ttcvalp">{{ 'myaccount.avl_points' | translate }}: {{availablepoints}}</span>
                
            </div>

          <div class="col-md-12 mb-4" *ngFor="let ord of orddata">
            <div class="profile-content orders-list">
            
            <div class="media my-order-box">
              
              <div class="media-body">
                <div class="row align-items-center">
                  <div class="col-md-5">
                <h5 class="ordnumber"><a [routerLink]="['/my-account/order-details', ord['orderid'] ]">Order#{{ord['orderid']}}</a></h5> 
                <p class="orddate"> {{ 'myaccount.date' | translate }}: {{ord['created_at'] | date : 'dd-MM-yyyy'}} </p>  
                </div>
                  <div class="col-md-6 text-right">
                    <h5 class="ordamnt"> 
                      {{ 'myaccount.l_points' | translate }}:  {{ord['rpoints']}}
                     &nbsp;
                     &nbsp;
                     &nbsp;&nbsp;&nbsp;
                     {{ 'myaccount.order_amount' | translate }}: AED {{ord['finalTotal']}}
                    </h5>
                </div>
                </div>
            </div>
          </div>
          </div>
        </div>

      </div>
    </div>

              </div>
          </div>
      </div>
  </section>
